import {PodExemptStatus} from '../../graphql/podExempt/types';

/** 状态 → AntD Tag 颜色 */
export const POD_EXEMPT_STATUS_COLOR: Record<PodExemptStatus, string> = {
  // 原型定色：待初审黄、待终审蓝——不能用 processing（跟随主题色会渲染成紫）
  PENDING_FIRST: 'gold',
  PENDING_FINAL: 'blue',
  EFFECTIVE: 'success',
  REJECTED: 'error',
  CLOSED: 'default',
  OFFLINE: 'default',
};

/** 状态 → i18n key（podExempt.status.*） */
export const POD_EXEMPT_STATUS_I18N: Record<PodExemptStatus, string> = {
  PENDING_FIRST: 'podExempt.status.pendingFirst',
  PENDING_FINAL: 'podExempt.status.pendingFinal',
  EFFECTIVE: 'podExempt.status.effective',
  REJECTED: 'podExempt.status.rejected',
  CLOSED: 'podExempt.status.closed',
  OFFLINE: 'podExempt.status.offline',
};


export const POD_EXEMPT_FLOW_ACTION_I18N: Record<string, string> = {
  SUBMIT: 'podExempt.flow.submit',
  FIRST_PASS: 'podExempt.flow.firstPass',
  FIRST_REJECT: 'podExempt.flow.firstReject',
  FINAL_PASS: 'podExempt.flow.finalPass',
  FINAL_REJECT: 'podExempt.flow.finalReject',
  CLOSE: 'podExempt.flow.close',
  SPOT_CHECK_MAINTAIN: 'podExempt.flow.spotCheckMaintain',
  SPOT_CHECK_OFFLINE: 'podExempt.flow.spotCheckOffline',
  MANUAL_OFFLINE: 'podExempt.flow.manualOffline',
};

/**
 * POD 免拍图片预览的根节点 class。
 *
 * 用于把「左右切换箭头下移到底部」这套样式限定在本模块内 —— 全局改 .ant-image-preview-*
 * 会波及 13 个无关组件，故所有 POD 免拍的预览都必须带上这个 rootClassName，
 * 对应样式见 src/index.css。
 */
export const POD_EXEMPT_PREVIEW_ROOT_CLASS = 'pod-exempt-image-preview';
